import { useSubscription } from '@system/subscriptions/useSubscription';

import { useExportFileInfo } from './subscribers/useExportFileInfo';
import { useExportFileSuccess } from './subscribers/useExportFileSuccess';
import { useNews } from './subscribers/useNews';
import { useRedirectToLogout } from './subscribers/useRedirectToLogout';

export function Subscriptions() {
  useSubscription();

  useRedirectToLogout();
  useNews();
  useExportFileInfo();
  useExportFileSuccess();
  return null;
}
